import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { IconArrowUpRight } from '@tabler/icons-react';

const Banner = () => {
  return (
    <>
      <section className='banner'>
        <Container>
          <Row>
            <Col md={12}>
              <h1>Your Trusted Partner for <span className='text-gradient'>International Financial Solutions</span></h1>
              <p>Specializing in currency exchange, letter of credit issuance, and global payment services for businesses and individuals across the globe.</p>
              <div className="btn-group gap-3">
                <Link to="/services" className='button blue custom'>Explore services <IconArrowUpRight size={20} stroke={2} /></Link>
                <Link to="/contact" className='button blue'>Contact us</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Banner